// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/pl_report.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PLReportItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.PLReportRequest
 */
export class PLReportRequest extends Message<PLReportRequest> {
  /**
   * Start date for the report (timestamp)
   *
   * @generated from field: int32 start_date = 1;
   */
  startDate = 0;

  /**
   * End date for the report (timestamp)
   *
   * @generated from field: int32 end_date = 2;
   */
  endDate = 0;

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 3;
   */
  pageNumber = 0;

  /**
   * Number of items per page for pagination
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<PLReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PLReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PLReportRequest {
    return new PLReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PLReportRequest {
    return new PLReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PLReportRequest {
    return new PLReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PLReportRequest | PlainMessage<PLReportRequest> | undefined, b: PLReportRequest | PlainMessage<PLReportRequest> | undefined): boolean {
    return proto3.util.equals(PLReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PLReportResponse
 */
export class PLReportResponse extends Message<PLReportResponse> {
  /**
   * List of PL report items
   *
   * @generated from field: repeated com.neulink.pharmacy.PLReportItem pl_report_items = 1;
   */
  plReportItems: PLReportItem[] = [];

  /**
   * Total number of items in the report
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<PLReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PLReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pl_report_items", kind: "message", T: PLReportItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PLReportResponse {
    return new PLReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PLReportResponse {
    return new PLReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PLReportResponse {
    return new PLReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PLReportResponse | PlainMessage<PLReportResponse> | undefined, b: PLReportResponse | PlainMessage<PLReportResponse> | undefined): boolean {
    return proto3.util.equals(PLReportResponse, a, b);
  }
}

